import { Grid, Tab, Tabs } from '@mui/material';
import { Link, Redirect, Route, Switch } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { MDTypography } from '../../../../../Component/Common/Components/MDTypography';
import { useRouteMatch } from '../../../../../Helpers/RouteMatcher';
import { InterventionDetails } from './InterventionDetails';
import { InterventionAtom as InterventionAtom } from '../Intervention.Atom';
import { InternalTrainers } from './Trainers/InternalTrainers';
import { MersetaInternalAttendees } from '../../../Attendees/MersetaInternalAttendees';
import { OrganisationAtom } from '../../../../../State/Organisation.Atom';
import { AncillaryCostsPage } from '../AncillaryCosts/AncillaryCostsPage';
import { TrainingTypes } from '../../../../../Component/Model/Enum/BEE123Enums';
import { BreadCrumb } from '../../../../../Component/Common/Components/BreadCrumb/BreadCrumb';

export const InternalTrainingBaseForm = () => {
    const routes = [
        "/organisation/training/Internal/form/Details",
        "/organisation/training/Internal/form/Attendees",
        "/organisation/training/Internal/form/cost",
        "/organisation/training/Internal/form/Trainers"
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    const currentTabIndex = routes.findIndex(route => route === currentTab);

    const handleRedirect = () => {
        if (currentTabIndex === -1) {
            return <Redirect to={routes[0]} />;
        }
        return null;
    };

    const selectedSDI = useRecoilValue(InterventionAtom);
    const SDIExists = selectedSDI.id > 0;

    return (
        <>
            <BreadCrumb
                titles={['Manage Training', 'Internal', 'Intervention']}
                hrefs={['/organisation/training/External', '/organisation/training/Internal', '']}
                currentLinkIndex={2}
            />

            <MDTypography variant="h4" style={{ paddingBottom: "20px" }}>
                {!SDIExists ? "Capture" : "Edit"} Internal Training
            </MDTypography>

            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="Intervention Details" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="Attendees" value={routes[1]} to={routes[1]} component={Link} disabled={!SDIExists} />
                        <Tab label="Ancillary Costs" value={routes[2]} to={routes[2]} component={Link} disabled={!SDIExists} />
                        <Tab label="Trainers" value={routes[3]} to={routes[3]} component={Link} disabled={!SDIExists} />

                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={3}>
                    <Switch>
                        {handleRedirect()}
                        <Route path={routes[0]}>
                            <InterventionDetails />
                        </Route>
                        <Route path={routes[1]}>
                            <MersetaInternalAttendees />
                        </Route>
                        <Route path={routes[2]}>
                            <AncillaryCostsPage interventionType={TrainingTypes.Internal} />
                        </Route>
                        <Route path={routes[3]}>
                            <InternalTrainers />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>

        </>

    )
}

